export default __webpack_public_path__ + "static/media/SearchFilter.cb38acae.PNG";